import { render, staticRenderFns } from "./crearCuponVendedor.vue?vue&type=template&id=74a87180&scoped=true&"
import script from "./crearCuponVendedor.vue?vue&type=script&lang=js&"
export * from "./crearCuponVendedor.vue?vue&type=script&lang=js&"
import style0 from "./crearCuponVendedor.vue?vue&type=style&index=0&id=74a87180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a87180",
  null
  
)

export default component.exports